


























































































import { staffList } from "@/api/globalSearch";
import { Prop, Vue, Component, Watch } from "vue-property-decorator";
interface staffItemI {
  staff_id: number;
  name: string;
  selected?: boolean;
}
interface inputDataI {
  keyword: string;
}
@Component
export default class extends Vue {
  @Prop() defaultSelected?: any[];
  @Prop() originId!: number | number[];
  @Prop() jobIds?: number[];
  @Prop() multiple?: boolean;
  selectedList: staffItemI[] = []; // 多选的展示
  searchData: inputDataI = {
    keyword: "",
  };
  cacheData: inputDataI = {
    keyword: "",
  };
  activeTab: string = "onJob";
  onJobList: staffItemI[] = [];
  departList: staffItemI[] = [];
  selectorVisible: boolean = false;
  pulldownX: number = 0;
  pulldownY: number = 0;
  get selectedIds() {
    return this.selectedList.map((item) => {
      return item.staff_id;
    });
  }
  @Watch("defaultSelected")
  onDefaultSelectedChange(n: staffItemI[]) {
    this.setDefaultSelected(n);
  }
  created() {
    if (this.defaultSelected && this.defaultSelected.length > 0) {
      this.setDefaultSelected(this.defaultSelected);
    }
  }
  setDefaultSelected(arr: staffItemI[]) {
    if (arr) {
      this.selectedList = arr;
      if (!this.multiple && arr[0]) {
        this.searchData.keyword = arr[0].name;
      } else {
        this.searchData.keyword = "";
      }
    } else {
      this.selectedList = [];
      this.searchData.keyword = "";
    }
  }
  handleSelectorOpen(e: any) {
    // input focus之后展开下拉，过滤删除点击事件
    if (e.target && e.target.nodeName !== "I") {
      const selectedEl: any = this.$refs["staff-pull-down-selected"];
      this.pulldownX =
        e.pageX - e.offsetX - (selectedEl ? selectedEl.clientWidth : 0);
      this.pulldownY = e.pageY - e.offsetY + 42;
      this.selectorVisible = true;
    } else if (e.target.className.indexOf("selected-close-icon") < 0) {
      // 单选模式下的清除按钮
      this.searchData.keyword = "";
      this.$emit("update:originId", "");
      this.$emit("update:defaultSelected", []);
      this.$emit("change");
    }
  }
  handleSearch(keyword?: string) {
    staffList({
      page: 1,
      page_size: 50,
      key_word: keyword || "",
      status: 1,
      job_ids: this.jobIds || [],
    }).then((res: any) => {
      if (res.error_code === 0) {
        res.data.list.map((item: any) => {
          item.selected = this.selectedIds.indexOf(item.staff_id) >= 0;
        });
        this.onJobList = res.data.list;
      }
    });
    staffList({
      page: 1,
      page_size: 50,
      key_word: keyword,
      status: 2,
      job_ids: this.jobIds || [],
    }).then((res: any) => {
      if (res.error_code === 0) {
        res.data.list.map((item: any) => {
          item.selected = this.selectedIds.indexOf(item.staff_id) >= 0;
        });
        this.departList = res.data.list;
      }
    });
  }
  handleSearchFocus() {
    this.searchData.keyword = "";
    this.handleSearch(this.searchData.keyword);
  }
  handleSearchChange(v: string) {
    this.handleSearch(v);
  }
  handleSelect(data: staffItemI, index: number) {
    if (data.selected) {
      // 取消选中
      if (this.activeTab === "onJob") {
        this.onJobList[index].selected = false;
      } else {
        this.departList[index].selected = false;
      }
      const i = this.selectedList.findIndex((item) => {
        return item.staff_id === data.staff_id;
      });
      this.selectedList.splice(i, 1);
    } else {
      // 选中
      if (this.activeTab === "onJob") {
        if (!this.multiple) {
          this.onJobList.map((item) => {
            item.selected = false;
          });
        }
        this.onJobList[index].selected = true;
      } else {
        if (!this.multiple) {
          this.departList.map((item) => {
            item.selected = false;
          });
        }
        this.departList[index].selected = true;
      }
      if (this.multiple) {
        this.selectedList.push(data);
      } else {
        this.selectedList = [data];
        this.handleShadowClose();
      }
    }
    if (this.multiple) {
      this.$emit("update:originId", this.selectedIds);
    } else {
      this.$emit("update:originId", this.selectedIds[0]);
    }
    this.$emit("update:defaultSelected", this.selectedList);
    this.$emit("change");
  }
  deleteSelected(i: number, id: number) {
    // 多选点击删除
    const j = this.onJobList.findIndex((item) => {
      return item.staff_id === id;
    });
    const k = this.departList.findIndex((item) => {
      return item.staff_id === id;
    });
    if (j >= 0) {
      this.onJobList[j].selected = false;
    }
    if (k >= 0) {
      this.departList[k].selected = false;
    }
    this.selectedList.splice(i, 1);
    if (this.multiple) {
      this.$emit("update:originId", this.selectedIds);
    } else {
      this.$emit("update:originId", "");
    }
    this.$emit("update:defaultSelected", this.selectedList);
    this.$emit("change");
  }
  handleShadowClose() {
    this.selectorVisible = false;
    if (this.multiple) {
      this.searchData.keyword = "";
    } else {
      if (this.selectedList.length > 0) {
        this.searchData.keyword = this.selectedList[0].name;
      } else {
        this.searchData.keyword = "";
      }
    }
  }
}
